
import Api from "@/api/userService";
import { role_type_agent, role_type_enduser } from "@/constant/DataTypeOptions";
import ResultCodeType from "@/constant/ResultCodeType";
import LoginResultBean from "@/model/LoginResultBean";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { defineComponent, reactive, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export default defineComponent({
  name: "LoginPage",
  setup() {
    const { t } = useI18n();
    const lanValue = ref("zh-cn") as any;
    const store = useStore();
    const router = useRouter();
    const loginObj = reactive({
      username: "",
      password: "",
      language: "",
    });
    const options = [
      { label: "CN", value: "zh-cn" },
      { label: "EN", value: "en" },
      { label: "RU", value: "ru" },
    ];
    const loginF = () => {
      if (lanValue.value === "zh-cn") {
        loginObj.language = "CN";
      }
      if (lanValue.value === "en") {
        loginObj.language = "EN";
      }
      if (lanValue.value === "ru") {
        loginObj.language = "RUS";
      }
      Api.logIn(loginObj).then((res: LoginResultBean) => {
        if (res.err_no == ResultCodeType.success_200) {
          if (
            res.result.user_role &&
            (res.result.user_role.role_type === role_type_agent ||
              res.result.user_role.role_type === role_type_enduser)
          ) {
            Api.setToken(res.result["access-token"]);
            sessionStorage.setItem("token", res.result["access-token"]);
            sessionStorage.setItem(
              "user_role",
              JSON.stringify(res.result.user_role)
            );
            sessionStorage.setItem(
              "agent_info",
              JSON.stringify(res.result.agent_info)
            );
            sessionStorage.setItem("username", loginObj.username);
            router.push({ path: routerName.dashboard });
          } else {
            message.warning(t("notauserofthisplatform"));
          }
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const handleChangeLan = () => {
      store.commit("setLocalLanguage", lanValue.value);
      localStorage.setItem("wxbLan", JSON.stringify(lanValue.value));
      router.go(0);
    };
    const isUp = ref(false);
    const dropdownVisibleChange = (value: any) => {
      isUp.value = value;
    };

    onMounted(() => {
      if (localStorage.getItem("wxbLan")) {
        const lanType = JSON.parse(localStorage.getItem("wxbLan") as any);
        lanValue.value = lanType;
        store.commit("setLocalLanguage", lanType);
      }
    });

    return {
      loginObj,
      loginF,
      t,
      lanValue,
      options,
      handleChangeLan,
      dropdownVisibleChange,
      isUp,
    };
  },
});
